import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Helmet } from './helmet';
import { useSettings } from '../core/settings/use-settings';
export function StaticPageTitle({ children }) {
    const { branding: { site_name }, } = useSettings();
    return (_jsx(Helmet, { children: children ? (
        // @ts-ignore
        _jsxs("title", { children: [children, " - ", site_name] })) : undefined }));
}
